import { LoginWorkflowLayout } from "components/app/login-workflow-layout";
import { InlineBanner } from "components/ui/inline-banner";
import React from "react";

export const OutlookAdminConsentApproved: React.FC = () => (
    <LoginWorkflowLayout title="Approval recorded">
        <InlineBanner type="success">
            Your approval covers the whole organization. Colleagues can now connect their
            own Microsoft 365 mailboxes without being prompted again.
        </InlineBanner>
    </LoginWorkflowLayout>
);
